module.exports = __webpack_public_path__ + "static/img/introDownload.8c00d3d6.png";